<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="facility-heading">Bulk Import Courses &amp; Materials</div>

    <p>
      Step 1: upload the e-book PDFs and course thumbnails the workbook will reference by filename.
      Step 2: download the template, fill in the <strong>Materials</strong> and <strong>Courses</strong> sheets, and
      upload it &mdash; it links courses/materials to the files you uploaded in Step 1 by matching filenames.
    </p>

    <div class="mb-10"></div>
    <div class="facility-heading">Step 1a: Upload E-book PDFs</div>
    <div class="form-fields">
      <input type="file" accept=".pdf" multiple (change)="onPdfFilesSelected($event)" />
    </div>
    <div class="mb-10"></div>
    <div class="form-buttons">
      <button type="button" class="submit-form-button" (click)="uploadAllPdfs()" [disabled]="pdfFiles.length === 0 || isUploadingPdfs">
        @if (!isUploadingPdfs) {
          Upload {{ pdfFiles.length || '' }} PDF(s)
        } @else {
          <div class="loader"><img src="/assets/loader.gif" class="login-loader w-100"></div>
        }
      </button>
    </div>
    @if (pdfRows.length > 0) {
      <table class="bulk-import-error-table">
        <thead>
          <tr>
            <th>File</th>
            <th>Progress</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (row of pdfRows; track row.name) {
            <tr>
              <td>{{ row.name }}</td>
              <td>
                <div class="bulk-import-progress-track" [class.error]="row.state === 'error'">
                  <div class="bulk-import-progress-fill" [style.width.%]="row.progress"></div>
                </div>
              </td>
              <td>{{ row.state }}</td>
            </tr>
          }
        </tbody>
      </table>
    }

    <div class="mb-10"></div>
    <div class="facility-heading">Step 1b: Upload Thumbnails</div>
    <div class="form-fields">
      <input type="file" accept=".jpg,.jpeg,.png" multiple (change)="onThumbnailFilesSelected($event)" />
    </div>
    <div class="mb-10"></div>
    <div class="form-buttons">
      <button type="button" class="submit-form-button" (click)="uploadAllThumbnails()" [disabled]="thumbnailFiles.length === 0 || isUploadingThumbnails">
        @if (!isUploadingThumbnails) {
          Upload {{ thumbnailFiles.length || '' }} Thumbnail(s)
        } @else {
          <div class="loader"><img src="/assets/loader.gif" class="login-loader w-100"></div>
        }
      </button>
    </div>
    @if (thumbnailRows.length > 0) {
      <table class="bulk-import-error-table">
        <thead>
          <tr>
            <th>File</th>
            <th>Progress</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (row of thumbnailRows; track row.name) {
            <tr>
              <td>{{ row.name }}</td>
              <td>
                <div class="bulk-import-progress-track" [class.error]="row.state === 'error'">
                  <div class="bulk-import-progress-fill" [style.width.%]="row.progress"></div>
                </div>
              </td>
              <td>{{ row.state }}</td>
            </tr>
          }
        </tbody>
      </table>
    }

    <div class="mb-10"></div>
    <div class="facility-heading">Step 2: Import Workbook</div>
    <div class="form-buttons">
      <button type="button" class="submit-form-button" (click)="downloadTemplate()" [disabled]="isDownloading">
        @if (!isDownloading) {
          Download Template
        } @else {
          <div class="loader"><img src="/assets/loader.gif" class="login-loader w-100"></div>
        }
      </button>
    </div>

    <div class="mb-10"></div>
    <div class="form-fields">
      <input type="file" accept=".xlsx" (change)="onFileSelected($event)" />
    </div>

    <div class="mb-10"></div>
    <div class="form-buttons">
      <button type="button" class="submit-form-button" (click)="upload()" [disabled]="!selectedFile || isImporting">
        @if (!isImporting) {
          Upload &amp; Import
        } @else {
          <div class="loader"><img src="/assets/loader.gif" class="login-loader w-100"></div>
        }
      </button>
    </div>

    @if (result) {
      <div class="mb-10"></div>
      @if (result.success) {
        <p class="upload-success-badge">
          Import complete: {{ result.coursesCreated }} course(s) and {{ result.materialsCreated }} material(s) created.
        </p>
      } @else {
        <mat-error class="validation-error">
          Nothing was imported. Fix the following rows and re-upload:
        </mat-error>
        <table class="bulk-import-error-table">
          <thead>
            <tr>
              <th>Sheet</th>
              <th>Row</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            @for (error of result.errors; track error) {
              <tr>
                <td>{{ error.sheet }}</td>
                <td>{{ error.rowNumber }}</td>
                <td>{{ error.message }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
